import { defineMessages } from 'react-intl'

export default defineMessages({
  edit: {
    id: 'containers.SupplierProfile.components.Demo.edit',
    defaultMessage: 'Edit',
  },
  delete: {
    id: 'containers.SupplierProfile.components.Demo.delete',
    defaultMessage: 'Delete',
  },
  hide: {
    id: 'containers.SupplierProfile.components.Demo.hide',
    defaultMessage: 'Hide',
  },
  hideLabel: {
    id: 'containers.SupplierProfile.components.Demo.hide.label',
    defaultMessage: 'This demo has been hidden by the sourcing team, as per the client\'s request',
  },
  hideTitle: {
    id: 'containers.SupplierProfile.components.Demo.hide.title',
    defaultMessage: 'Hide demo on public website',
  },
  show: {
    id: 'containers.SupplierProfile.components.Demo.show',
    defaultMessage: 'Show',
  },
  showLabel: {
    id: 'containers.SupplierProfile.components.Demo.show.label',
    defaultMessage: 'This demo is visible on your public profile',
  },
  showTitle: {
    id: 'containers.SupplierProfile.components.Demo.show.title',
    defaultMessage: 'Show demo on public website ',
  },
  customDemoLabel: {
    id: 'containers.SupplierProfile.components.Demo.customDemo.label',
    defaultMessage: 'Custom Demo',
  },
  customDemoHint: {
    id: 'containers.SupplierProfile.components.Demo.customDemo.hint',
    defaultMessage: 'This demo is not visible on your public profile, but has been sent to a client for an audition',
  },
  voiceLibraryLabel: {
    id: 'containers.SupplierProfile.components.Demo.customDemo.vllabel',
    defaultMessage: 'Voice Library',
  },
  voiceLibraryHint: {
    id: 'containers.SupplierProfile.components.Demo.voiceLibrary.vlhint',
    defaultMessage: 'This demo has been set as a default for a client',
  },
  dialectLabel: {
    id: 'containers.SupplierProfile.components.Demo.customDemo.dialectLabel',
    defaultMessage: 'Dialect',
  },
  dialectHint: {
    id: 'containers.SupplierProfile.components.Demo.voiceLibrary.dialectHint',
    defaultMessage: 'This demo has a {dialect} dialect',
  },
  download: {
    id: 'containers.SupplierProfile.components.Demo.download.label',
    defaultMessage: 'Download',
  },
})
